import { useMatch } from 'react-router-dom';

export interface BreadcrumbRoutes {
    isLocationRoute: boolean;
    isCageRoute: boolean;
    /** The client overview itself: the location dropdown shows with nothing chosen. */
    showLocationsOnClientOverview: boolean;
    /** The location overview itself: the pen dropdown shows with nothing chosen. */
    showCagesOnLocationOverview: boolean;
}

/** Which levels of the client, location and pen trail the current page sits under. */
export function useBreadcrumbRoutes(pagePath: string): BreadcrumbRoutes {
    // Prefix matches: any page under the client, location or pen counts.
    const isClientRoute = !!useMatch({ path: '/c/:clientId', end: false });
    const isLocationRoute = !!useMatch({ path: '/c/:clientId/location/:locationId', end: false });
    const isCageRoute = !!useMatch({
        path: '/c/:clientId/location/:locationId/pen/:cageId',
        end: false,
    });

    const isLastPartEmpty = pagePath === '/' || pagePath === '';
    const showLocationsOnClientOverview =
        isClientRoute && isLastPartEmpty && !isLocationRoute && !isCageRoute;
    const showCagesOnLocationOverview = isLocationRoute && isLastPartEmpty && !isCageRoute;

    return {
        isLocationRoute,
        isCageRoute,
        showLocationsOnClientOverview,
        showCagesOnLocationOverview,
    };
}
